import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-tryangle_right1",
  "use": "vab-icon-tryangle_right1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-tryangle_right1\">\n<path d=\"M9.17905 7.64205C9.38498 7.83965 9.38498 8.16002 9.17905 8.35762L6.23366 11.184C5.90147 11.5027 5.3335 11.277 5.3335 10.8262L5.3335 5.1735C5.3335 4.72272 5.90148 4.49696 6.23366 4.81572L9.17905 7.64205Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol